/**
 * Airline logos from the airlogos npm package (IATA → base64 svg/png).
 * Loaded on demand (~4.7MB) when Flight Manager mounts.
 * Coverage is not exhaustive; missing codes return null.
 */

let airlineLogosCache = null;
let airlineLogosPromise = null;

/**
 * Preload airlogos (call from FlightManager mounted).
 * @returns {Promise<object>}
 */
export function preloadAirlineLogos() {
  if (airlineLogosCache) {
    return Promise.resolve(airlineLogosCache);
  }
  if (!airlineLogosPromise) {
    airlineLogosPromise = import(/* webpackChunkName: "airlogos" */ 'airlogos')
      .then((module) => {
        airlineLogosCache = module.default || module;
        return airlineLogosCache;
      })
      .catch((err) => {
        console.error('Failed to load airlogos', err);
        airlineLogosCache = {};
        return airlineLogosCache;
      });
  }
  return airlineLogosPromise;
}

/**
 * @param {string|null|undefined} iataCode
 * @param {{ forBadge?: boolean }} [options] - badge UI prefers PNG (often squarer at small sizes)
 * @returns {string|null} data URL for img src, or null if unavailable / not yet loaded
 */
export function getNpmAirlineLogoUrl(iataCode, options = {}) {
  const { forBadge = true } = options;
  if (!airlineLogosCache || !iataCode || typeof iataCode !== 'string') return null;
  const code = iataCode.trim().toUpperCase();
  if (!/^[A-Z0-9]{2}$/.test(code)) return null;

  const entry = airlineLogosCache[code];
  if (!entry) return null;
  if (forBadge) {
    if (entry.png) return entry.png;
    if (entry.svg) return entry.svg;
  } else if (entry.svg) {
    return entry.svg;
  } else if (entry.png) {
    return entry.png;
  }
  return null;
}
